import React from "react";
import { Link } from "react-router-dom";
import "../css/payfail.css";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const PayFail = () => {
  return (
    <>
      <Header />
      <div className="failDiv">
        <div className="fail-container">
          <div className="modal-content">
            <div className="crossmark-circle">
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <h2>Payment Failed</h2>
            <p className="fail-message">
              Oops! Something went wrong with your payment. Your order has not been placed.
            </p>

            <div className="fail-actions">
              <Link to="/checkout" className="btn-retry-payment">
                Try Again
              </Link>
              <Link to="/cartpage" className="btn-back-to-cart">
                Return to Cart
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PayFail;